import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";
import {
  FaInstagram,
  FaFacebookF,
  FaTiktok,
  FaLinkedinIn,
} from "react-icons/fa";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column">
          <h3 className="column-title">Returns/Delivery</h3>
          <ul className="footer-links">
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns Policy
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" onClick={toTop}>
                Terms Of Service
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="column-title">About Us</h3>
          <ul className="footer-links">
            <li>
              <Link to="/about" onClick={toTop}>
                Our Story
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column newsletter-column">
          <h3 className="column-title">Join the Movement</h3>
          <p>enter@parkhaven.cloud</p>
          <p>413 Carrington Ln, Douglasville, GA 30135US</p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="location">
          <FiMapPin className="pin-icon" />
          <span>United States | Global (English)</span>
        </div>
        <div className="copyright">©2026 Parkhaven. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
